import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import NotFound from './views/NotFound.vue'
import Preview from './views/Preview.vue'
import Currently from './components/Currently.vue'
import Page from './components/Page.vue'

Vue.use(Meta)
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home'
    },
    {
      path: '/not-found',
      name: 'not-found',
      component: NotFound
    },
    {
      path: '/preview',
      name: 'preview',
      component: Preview
    },
    {
      path: '/about',
      name: 'about',
      alias: '/'
    },
    {
      path: '/the-community',
      name: 'the-community',
      alias: '/'
    },
    {
      path: '/clients',
      name: 'clients',
      alias: '/'
    },
    {
      path: '*',
      redirect: { name: 'home' }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
	    return {
	      selector: '#' + to.name
	      // , offset: { x: 0, y: 10 }
	    }
	}
})
